<template>
	<div class="inner-page form-submissions">

		<AppHead :title="`Form Submissions for case #${caseName}`" />

		<PageHeader 
			:title="`Form Submissions for case: #${caseName}`"
			:hasButton="false"
			:showHelper="false"
			/>

		<TableFormResults 
			:formResults="formResults"
			:caseHash="caseHash"
			:surveyJSKey="surveyJSKey"
			:case="case"
			/>

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import TableFormResults from "@/Components/TableFormResults.vue"

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		TableFormResults
	},
	layout: AppLayout,
	props: {
		formResults: {
			type: [Array, Object, Boolean],
			default: false
		},
		case: {
			type: Object,
			required: true
		},
		surveyJSKey: {
			type: String,
			required: true
		}
	},
	data: () => {
		return {
			
		}
	},
	mounted() {
		// console.log('formResults', this.formResults)
	},
	computed: {
		caseHash() {
			return this.case.hashid
		},
		caseName() {
			return this.case && this.case.enquiry_number ? this.case.enquiry_number : this.case.hashid
		}
	}
}

</script>